// Shared supplemental-plan quiz (ACA page module + chat widget)
export const HOSPITAL_EXPENSE_URL =
  "https://customer.enroll.natgenhealth.com/quick-quote/?agent=CfDJ8KcuJeU1UfVFhwatU8NLwQl7-pF18Le6lw2-62Tl1CzVtMNfxrBEKvkNzZ2Dh-y_cvEe2-wKp-uCdrKU1D1sEBIuKQ&product=hospital-expense";

export const LIFE_CANCER_CI_URL =
  "https://customer.enroll.natgenhealth.com/quick-quote/?agent=CfDJ8KcuJeU1UfVFhwatU8NLwQl7-pF18Le6lw2-62Tl1CzVtMNfxrBEKvkNzZ2Dh-y_cvEe2-wKp-uCdrKU1D1sEBIuKQ&product=life-cancer-critical-illness";

export const ACA_COMPARE_QUIZ = [
  {
    id: "worry",
    question: "What worries you most about a big medical event?",
    answers: [
      { label: "A hospital stay or ER visit", scoreFor: "left" },
      { label: "A serious illness like cancer or stroke", scoreFor: "right" },
    ],
  },
  {
    id: "life",
    question: "Do you already carry term life insurance?",
    answers: [
      { label: "Yes, I'm covered", scoreFor: "left" },
      { label: "No, or not enough", scoreFor: "right" },
    ],
  },
  {
    id: "budget",
    question: "What matters more right now?",
    answers: [
      { label: "Lowest possible premium", scoreFor: "left" },
      { label: "One policy, broader safety net", scoreFor: "right" },
    ],
  },
];

export const QUIZ_RESULTS = {
  left: {
    id: "hospital",
    title: "Hospital-only indemnity",
    summary: "Simplest and lowest-priced — pays a fixed cash benefit for hospital admissions and ER visits.",
    ctaLabel: "See hospital-only plans",
    ctaUrl: HOSPITAL_EXPENSE_URL,
    pagePath: "/aca-health#aca-indemnity-module",
    trackId: "chat-quiz-hospital",
  },
  right: {
    id: "bundle",
    title: "Life + cancer + critical illness bundle",
    summary: "One policy, one premium — term life plus lump-sum benefits for cancer, heart attack or stroke.",
    ctaLabel: "See the bundle option",
    ctaUrl: LIFE_CANCER_CI_URL,
    pagePath: "/aca-health#aca-indemnity-module",
    trackId: "chat-quiz-bundle",
  },
  tie: {
    id: "tie",
    title: "Even match",
    summary: "Either could fit — Christian can price both side by side in a few minutes.",
    ctaLabel: "Compare both options",
    ctaUrl: null,
    pagePath: "/aca-health#aca-indemnity-module",
    trackId: "chat-quiz-tie",
  },
};

// answers: array of "left" | "right"
export const scoreQuiz = (answers) => {
  const left = answers.filter((a) => a === "left").length;
  const right = answers.length - left;
  if (left === right) return QUIZ_RESULTS.tie;
  return left > right ? QUIZ_RESULTS.left : QUIZ_RESULTS.right;
};
